import React from "react";
import { Avatar } from "@mui/material";
import BinanceSVG from "@/svgs/binance-logo.svg?react";
import BithumbSvg from "@/svgs/bithumb-logo.svg?react";
import BtcTurkSvg from "@/svgs/btcturk-logo.svg?react";
import ByBitSvg from "@/svgs/bybit-logo.svg?react";
import CoinbaseSVG from "@/svgs/coinbase-logo.svg?react";
import CoinRoutesSvg from "@/svgs/coinroutes-logo.svg?react";
import UpbitSvg from "@/svgs/upbit-logo.svg?react";

const Logo: React.FC<{ venue: string | null | undefined }> = React.memo(
  ({ venue }) => {
    switch (venue) {
      case "BTMB":
        return <BithumbSvg />;
      case "BIN":
      case "BINF":
      case "BINP":
      case "BINC":
        return <BinanceSVG />;
      case "BYBT":
        return <ByBitSvg />;
      case "BTRK":
        return <BtcTurkSvg />;
      case "CNB":
        return <CoinbaseSVG />;
      case "CNR":
        return <CoinRoutesSvg />;
      case "UPB":
        return <UpbitSvg />;
      default:
        return null;
    }
  }
);

const VenueCell: React.FC<{ value: string | null | undefined }> = React.memo(
  ({ value }) => {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Avatar alt={value || ""} sx={{ width: "24px", height: "24px" }}>
          <Logo venue={value} />
        </Avatar>
      </div>
    );
  }
);

export default VenueCell;
